module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0129.jpg?v=d875af94";